export default __webpack_public_path__ + "static/burgtor_friedberg_kaiserstrasse-dfbab3ef54305b5616a96c793bef9025.jpg";